import React, { useState } from 'react'
import { useAppSelector } from '../../../../slices/store'
import { Input } from '../../../../ui/Input/Input';
import { Button } from '../../../../ui/Button/Button';
import { StyledAddSongs } from './styles';
import { MdModeEdit, MdDelete, MdClose } from "react-icons/md";
import { IconWrapper } from '../../../../ui/IconWrapper/IconWrapper';
import { getWebSocket } from '../../../../socket/socket';
import { EStages } from '../../../../utils/types';
import { useTranslation } from 'react-i18next';

export const AddSongs = () => {
  const {isAdmin, songs: songsFromStore} = useAppSelector((s) => s.mainStore);
  const [currentSong, setCurrentSong] = useState('');
  const [songs, setSongs] = useState<string[]>(songsFromStore || []);
  const [isSent, setIsSent] = useState(!!songsFromStore.length);

  const { t } = useTranslation();
  const translationPrefix = 'music_mafia.add_songs';

  const handleAddSong = () => {
    if (currentSong) {
      setSongs([currentSong, ...songs])
      setCurrentSong('');
    }
  };

  const handleDeleteSong = (index: number) => {
    songs.splice(index, 1);
    setSongs([...songs]);
    console.log('del', index, songs);
  };

  const handleSendSongs = () => {
    const ws = getWebSocket();
    ws?.send(JSON.stringify({type: EStages.add_songs, songs}));
    setIsSent(true);
  };

  return (
    <StyledAddSongs>
      {!isSent ?
        <div className='song-input'>
          <Input value={currentSong} onEnter={handleAddSong} onChange={setCurrentSong} placeholder={t(`${translationPrefix}.placeholder`)} />
          <Button title='+' width={40} handleClick={handleAddSong} />
        </div> :
        <div>
          {t(`${translationPrefix}.songs_list`)}
        </div>
      }
      {!!songs.length && (
        <>
          <div className='songs-list'>
            {songs.map((song, index) => (
              <div key={song} className='song-list-item'>
                <Input value={song} disabled 
                addon={
                  !isSent ? <IconWrapper style={{width: '40px'}} onClick={() => handleDeleteSong(index)}>
                    <MdClose size={20} />
                  </IconWrapper> : undefined
                }
                />
              </div>
            ))}
          </div>
          {!isSent && <Button title={t(`${translationPrefix}.button_send`)} handleClick={handleSendSongs} />}
        </>
      )}
    </StyledAddSongs>
  )
}
